import ContentOverlay from "../components/content_overlay";
import { Link } from "react-router-dom";

function AbstractPage() {
  return (
    <ContentOverlay
      heading={
        <h2
          style={{
            textAlign: "center",
            fontFamily: "Nunito",
          }}
        >
          {" "}
          <b>Abstract</b>
        </h2>
      }
      text_content={
        <div>
          <p
            className="container"
            style={{
              fontSize: "0.8em",
              fontFamily: "Nunito",
            }}
          >
            <p>
              Sustainability of a bioenergy project depends on precise
              assessment of biomass resource, planning of cost-effective
              logistics and evaluation of possible environmental implications.
              In this context, this paper reviews the role and applications of
              geo-spatial tool such as Geographical Information System (GIS) for
              precise agro-residue resource assessment, biomass logistic and
              power plant design. Further, application of Life Cycle Assessment
              (LCA) in understanding the potential impact of agro-residue
              bioenergy genera- tion on different ecosystem services has also
              been reviewed and limitations associated with LCA variabil- ity
              and uncertainty were discussed. Usefulness of integration of GIS
              into LCA (i.e. spatial LCA) to overcome the limitations of
              conventional LCA and to produce a holistic evaluation of the
              environmental benefits and concerns of bioenergy is also reviewed.
              Application of GIS, LCA and spatial LCA can help alleviate the
              challenges faced by ambitious bioenergy projects by addressing
              both economics and environmental goals.
            </p>
            <p>
              <strong>KEYWORDS</strong>:&nbsp;Macrophytes, Bengaluru, Jakkur
              Lake, Heavy metal
            </p>
            <br />
            <br />
            <hr />
            <br />
          </p>
        </div>
      }
    />
  );
}
export default AbstractPage;
